import { getToken, onMessage } from 'firebase/messaging';
import { messaging } from './app';
import { VAPID_KEY } from './config';

export const getMessagingToken = async (): Promise<string | null> => {
  try {
    const token = await getToken(messaging, { vapidKey: VAPID_KEY });
    return token || null;
  } catch (error) {
    console.error('[FCM] Error getting doctor FCM token:', error);
    return null;
  }
};

export const onForegroundMessage = (callback: (payload: any) => void) => {
  return onMessage(messaging, (payload) => {
    callback(payload);
  });
};
